export class Country {
    public country_code: string;
    public lat: number;
    public lng: number;
}
